module.exports = __webpack_public_path__ + "static/media/tinywow_Betula3500x_colored_55476049.25f51344.jpg";